<template>
  <app-page-title :color="'lips'">
    <template #pageTitleLeft>
      <h1>
        Transaction Summary
      </h1>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'

  export default {
    components: {
      AppPageTitle
    }
  }
</script>
